import { ShareRoomFragment } from "~/__generated__/graphql"
import { cn } from "~/common/cn"
import { AppText } from "~/ui/app-text"

const DEFAULT_LABEL = "Presented by"

interface PresentedByProps {
  roomData: ShareRoomFragment
  className?: string
}

export const PresentedBy = ({ roomData, className }: PresentedByProps): JSX.Element | null => {
  const sponsorCreative = roomData.sponsorCreative
  if (!sponsorCreative) return null

  const { imageUrl, labelText, sponsor } = sponsorCreative

  return (
    <div
      className={cn("flex flex-row items-center justify-center gap-2 px-4 pb-2 pt-4", className)}
    >
      <AppText variant="body3-medium" className="text-base-white/70">
        {labelText || DEFAULT_LABEL}
      </AppText>

      {imageUrl ? (
        // Room creatives are monochrome and painted with `currentcolor`, which an
        // <img> resolves to black. The share page is always the blue gradient, so
        // force the logo white rather than inlining the SVG (CSP connect-src does
        // not allow fetching from the image CDN).
        <img
          src={imageUrl}
          alt={sponsor.displayName}
          className="h-[24px] w-auto max-w-[140px] object-contain [filter:brightness(0)_invert(1)]"
        />
      ) : (
        <AppText variant="body3-medium" className="text-base-white">
          {sponsor.displayName}
        </AppText>
      )}
    </div>
  )
}
